import { render, staticRenderFns } from "./OrdersContainer.vue?vue&type=template&id=051d4482"
import script from "./OrdersContainer.vue?vue&type=script&lang=ts"
export * from "./OrdersContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports